<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
    <el-row @keyup.enter.native="loadData(1)">
      <el-input v-model="queryField.user_id" size="small" placeholder="用户ID"></el-input>
      <el-input v-model="queryField.user_name" size="small" placeholder="用户名"></el-input>
      <el-input v-model="queryField.nick_name" size="small" placeholder="昵称"></el-input>
      <el-input v-model="queryField.phone" size="small" placeholder="手机号码"></el-input>
      <el-input v-model="queryField.main_user_id" size="small" placeholder="总账号id"></el-input>
      <el-date-picker
          size="small"
          v-model="queryField.start_time"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
          size="small"
          v-model="queryField.end_time"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期">
      </el-date-picker>
      <el-button type="primary" @click="loadData(1)" icon="el-icon-search" size="small">查询</el-button>
      <el-button type="primary" @click="goUserAddPage" icon="el-icon-plus" size="small">新增</el-button>
      <el-button v-if="groupId === '1'" type="primary" @click="doOpenBatch" icon="el-icon-plus" size="small">批量新增</el-button>
    </el-row>
    <el-table class="cps-table-data"
                :data="tableData" size="small"
                border
                :height="height"
                style="width: 100%">

      <el-table-column
              prop="user_id"
              label="用户ID"
              width="80">
      </el-table-column>
      <el-table-column
              prop="user_name"
              label="用户名"
              width="230">
      </el-table-column>
      <el-table-column
              prop="nick_name"
              label="昵称"
              width="230">
      </el-table-column>
      <el-table-column
              prop="phone"
              label="手机号码"
              width="120">
      </el-table-column>
      <el-table-column
          prop="main_user_id"
          label="主账号id"
          width="120">
      </el-table-column>
      <el-table-column
              prop="child_status"
              :show-overflow-tooltip="true"
              :formatter="formatChildStatus"
              label="子账号状态"
              width="100">
      </el-table-column>
      <el-table-column
              prop="add_time"
              label="新增时间"
              width="140">
      </el-table-column>
      <el-table-column
              label="操作">
          <template slot-scope="scope">
            <el-button @click="detail(scope.row.user_id)" type="text" size="small">详情</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination class="fixed-pagination"
            @current-change="loadData"
            background
            :current-page="currentIndex"
            :page-size="15"
            layout="total, prev, pager, next"
            :total="total">
    </el-pagination>

      <el-drawer
          title="批量添加"
          :visible.sync="isBatch"
          :close-on-press-escape="false"
          :wrapperClosable="false"
          direction="rtl">
        

        <div style="margin: 0 20px;">
          <el-tabs v-model="activeName" @tab-click="handleTabsClick">
            <el-tab-pane label="批量用户" name="user">
              <el-form ref="userForm" :rules="userRules" :model="userForm" label-width="110px" class="batch__form">
                <el-form-item label="渠道id" prop="adminId">
                  <el-input v-model="userForm.adminId" size="small" placeholder="归属渠道id"></el-input>
                </el-form-item>
                <el-form-item label="账号前缀" prop="accountPrefix">
                  <el-input v-model="userForm.accountPrefix" size="small" placeholder="例：taohuali"></el-input>
                </el-form-item>
                <el-form-item label="账号后缀起始" prop="accountSuffixBegin">
                  <el-input v-model.number="userForm.accountSuffixBegin" size="small" placeholder="例：输入2,将会从2开始到结束值"></el-input>
                </el-form-item>
                <el-form-item label="账号后缀结束" prop="accountSuffixEnd">
                  <el-input v-model.number="userForm.accountSuffixEnd" size="small" placeholder="例：输入10,将会从起始值到10"></el-input>
                </el-form-item>
                <el-form-item label="账号密码" prop="password">
                  <el-input v-model="userForm.password" minlength="6" n maxlength="20" size="small" placeholder="密码为6-20位数字、字母、特殊符号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button @click="doCreateUser('userForm')" type="primary">创建</el-button>
                  <el-button @click="doCloseBatch">取消</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="批量加币" name="coin">
              <el-form ref="coinForm" :rules="coinRules" :model="coinForm" label-width="110px" class="batch__form">
                <el-form-item label="账号前缀" prop="accountPrefix">
                  <el-input v-model="coinForm.accountPrefix" size="small" placeholder="例：taohuali"></el-input>
                </el-form-item>
                <el-form-item label="账号后缀起始" prop="accountSuffixBegin">
                  <el-input v-model.number="coinForm.accountSuffixBegin" size="small" placeholder="例：输入2,将会从2开始到结束值"></el-input>
                </el-form-item>
                <el-form-item label="账号后缀结束" prop="accountSuffixEnd">
                  <el-input v-model.number="coinForm.accountSuffixEnd" size="small" placeholder="例：输入10,将会从起始值到10"></el-input>
                </el-form-item>
                <el-form-item label="充值游戏" prop="gameId">
                  <el-select
                      size="small"
                      ref="selectGame"
                      v-model="game"
                      filterable
                      remote
                      reserve-keyword
                      style="width: 100%;"
                      placeholder="游戏名称"
                      @change="handleSelect"
                      :remote-method="loadGame"
                      @visible-change="cancelReadOnly"
                  >
                    <el-option
                        v-for="item in restaurants"
                        :key="item.key"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="充值金额" prop="amount">
                  <el-input v-model.number="coinForm.amount" size="small" placeholder="充值金额"></el-input>
                </el-form-item>
                <el-form-item label="支付密码" prop="payPassword">
                  <el-input v-model="coinForm.payPassword" type="password" size="small" placeholder="支付密码"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input v-model.number="coinForm.remark" size="small" placeholder="备注"></el-input>
                </el-form-item>
                <el-form-item label="是否赠送">
                  <el-radio-group v-model="coinForm.isFree">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item>
                  <el-button @click="doAddCoin('coinForm')" type="primary">确认</el-button>
                  <el-button @click="doCloseBatch">取消</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-drawer>
      
  </div>
  </div>
</template>
<script>
import {batchAddCoin, createUser, loadGame, queryMyUserList} from '@/api/request'
import Crypto from "@/utils/crypto";

export default {
    name: 'userList',
    data() {
      let verifyNumberEnd = (rule, value, callback) => {
        if(value < this.userForm.accountSuffixBegin) {
          callback(new Error('结束值应大于起始值'))
        }

        let v = value - this.userForm.accountSuffixBegin;
        if(v < 1 || v > 200){
          callback(new Error('一次最多创建200个账号'))
        }
        callback();
      }
      let verifyCoinFormNumberEnd = (rule, value, callback) => {
        if(value < this.coinForm.accountSuffixBegin) {
          callback(new Error('结束值应大于起始值'))
        }

        let v = value - this.coinForm.accountSuffixBegin;
        if(v < 1 || v > 200){
          callback(new Error('一次最多为200个账号加币'))
        }
        callback();
      }
      return {
        tableData: [],
        queryField: {
          user_id: '',
          user_name: '',
          nick_name: '',
          phone: '',
          main_user_id:'',
          start_time:'',
          end_time:''
        },
        total: 0,
        currentIndex:1,
        height: window.innerHeight - 210,
        loading:false,
        isBatch: false,
        groupId: '',
        activeName: 'user',
        userForm: {
          adminId: '',
          accountPrefix: '',
          accountSuffixBegin: '',
          accountSuffixEnd: '',
          password: '',
        },
        userRules: {
          adminId: [
            { required: true, message: '请输入渠道Id', trigger: 'blur' },
          ],
          accountPrefix: [
            { required: true, message: '请输入账号前缀', trigger: 'blur' },
            { min: 5, max: 8, message: '长度在 5 到 8 个字符', trigger: 'blur' }
          ],
          accountSuffixBegin: [
            { required: true, message: '请输入账号后缀起始值', trigger: 'blur' },
            { type: 'number', message: '账号后缀必须为数字'},
          ],
          accountSuffixEnd: [
            { required: true, message: '请输入账号后缀结束值', trigger: 'blur' },
            { type: 'number', message: '账号后缀必须为数字'},
            { validator: verifyNumberEnd,trigger: 'blur'}
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { pattern: /^[a-zA-Z0-9~!@#$%^&*()_+]{6,20}$/, message: '密码为6-20位数字字母特殊符号', trigger: 'blur' },
          ],
        },
        game: '',
        restaurants: [],
        coinForm: {
          accountPrefix: '',
          accountSuffixBegin: '',
          accountSuffixEnd: '',
          gameId: '',
          amount: '',
          payPassword: '',
          remark: '',
          isFree: 0,
        },
        coinRules: {
          accountPrefix: [
            { required: true, message: '请输入账号前缀', trigger: 'blur' },
            { min: 5, max: 8, message: '长度在 5 到 8 个字符', trigger: 'blur' }
          ],
          accountSuffixBegin: [
            { required: true, message: '请输入账号后缀起始值', trigger: 'blur' },
            { type: 'number', message: '账号后缀必须为数字'},
          ],
          accountSuffixEnd: [
            { required: true, message: '请输入账号后缀结束值', trigger: 'blur' },
            { type: 'number', message: '账号后缀必须为数字'},
            { validator: verifyCoinFormNumberEnd,trigger: 'blur'}
          ],
          gameId: [
            { required: true, message: '请选择游戏', trigger: 'blur' },
          ],
          amount: [
            { required: true, message: '请输入充值金额', trigger: 'blur' },
          ],
          payPassword: [
            { required: true, message: '请输入支付密码', trigger: 'blur' },
          ]
        }
      }
    },
    mounted() {
      this.groupId = JSON.parse(localStorage.getItem("userInfo")).groupId;
      this.loadData(1);
    },
    methods: {
      loadData(index) {
        if (this.queryField.start_time) {
          this.queryField.start_time += " 00:00:00";
        } else {
          this.queryField.start_time = "";
        }

        if (this.queryField.end_time) {
          this.queryField.end_time += " 23:59:59";
        } else {
          this.queryField.end_time = "";
        }
        let params = {
          pageNo: index,
          pageSize: 15,
          params: this.queryField
        }
        queryMyUserList(params).then(res => {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.currentIndex=index
        })
      },
      handleTabsClick(tab, event) {
        this.$refs.userForm.resetFields();
        this.$refs.coinForm.resetFields();

        this.game = '';
        this.coinForm.isFree = 0;
      },
      doCreateUser(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              adminId: this.userForm.adminId,
              accountPrefix: this.userForm.accountPrefix,
              accountSuffixBegin: this.userForm.accountSuffixBegin,
              accountSuffixEnd: this.userForm.accountSuffixEnd,
              password: Crypto.encrypt(this.userForm.password),
            }
            createUser(params).then(res => {
              if(res.data.success){
                this.$message.success('创建成功');
                this.doCloseBatch();
              }else {
                this.$message.error(res.data.error.message)
              }
            })
          } else {
            return false;
          }
        });
      },
      doAddCoin(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              accountPrefix: this.coinForm.accountPrefix,
              accountSuffixBegin: this.coinForm.accountSuffixBegin,
              accountSuffixEnd: this.coinForm.accountSuffixEnd,
              gameId: this.coinForm.gameId,
              amount: this.coinForm.amount,
              payPassword: Crypto.encrypt(this.coinForm.payPassword),
              remark: this.coinForm.remark,
              isFree: this.coinForm.isFree,
            }
            batchAddCoin(params).then(res => {
              if(res.data.success){
                this.$message.success('充值成功');
                this.doCloseBatch();
              }else {
                this.$message.error(res.data.error.message)
              }
            })
          } else {
            return false;
          }
        });
      },
      doOpenBatch() {
        this.isBatch = true;
      },
      doCloseBatch() {
        this.isBatch = false;
        this.$refs.userForm.resetFields();
        this.$refs.coinForm.resetFields();
        
        this.game = '';
        this.coinForm.isFree = 0;
      },
      loadGame(query){
        if (query !== '') {
          let me = this;
          loadGame(query).then(res => {
            me.restaurants = [];
            res.data.data.forEach(function (e) {
              let item = {}
              item.key = e.game_id
              item.value = e.game_id
              item.label = e.game_name
              me.restaurants.push(item)
            })
          })
        }
      },
      handleSelect(item){
        this.coinForm.gameId = item
      },
      cancelReadOnly(value){
        this.$nextTick(() => {
          if (!value) {
            const {selectGame} = this.$refs;
            const input = selectGame.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
            this.$refs.selectGame.blur();
          }
        });
      },
      detail(userId) {
        console.log(userId)
        this.$router.push({ path: `/userList/userDetail/${userId}`});
      },
      goUserAddPage() {
        this.$router.push({ path: "/userList/userAdd" });
      },
      formatChildStatus(row, column, cellValue) {
        let ret = ''
        if (cellValue===1) {
          ret = "是"
        } else {
          ret = "否"
        }
        return ret;
      },

    },
  }
</script>
<style scoped>
/deep/ .is-active {
  background-color: #fff !important;
}
.batch__form /deep/ .el-input__inner {
  width: 90%;
}
</style>
